module.exports = __webpack_public_path__ + "img/sv84.9b4ddf1c.svg";